import { defineMessage } from "react-intl";

/**
 * @typedef {object} Contract
 * @property {import("react-intl").MessageDescriptor} name
 * @property {import("@raiden/library/types/Contract").ContractType} value
 * @property {string} icon
 */

/** @type {Contract[]} */
export const CONTRACTS_LIST = [
  {
    name: defineMessage({ defaultMessage: "Énergie" }),
    value: "energy",
    icon: "ms_emoji_objects",
  },
  {
    name: defineMessage({ defaultMessage: "Télécoms" }),
    value: "telecom",
    icon: "ms_smartphone",
  },
  {
    name: defineMessage({ defaultMessage: "Assurance" }),
    value: "insurance",
    icon: "ms_policy",
  },
  {
    name: defineMessage({ defaultMessage: "Finance" }),
    value: "finance",
    icon: "ms_savings",
  },
];

export const CONTRACTS_MAP = new Map(
  CONTRACTS_LIST.map((item) => [item.value, item]),
);
